<template>
  <div class="legal-page" :class="{ 'mobile': isMobile, 'desktop': !isMobile }">
    <h1>特定商取引法に基づく表記</h1>
    <dl>
      <dt>事業者名</dt>
      <dd>メノア株式会社</dd>

      <dt>所在地</dt>
      <dd>東京都渋谷区 渋谷1-1-3 アミーホール</dd>

      <dt>代表者</dt>
      <dd>代表取締役 吉川雄司</dd>

      <dt>お問い合わせ先</dt>
      <dd>info@menoah.jp</dd>

      <dt>利用料</dt>
      <dd>購入手続きの際に画面に表示されます。消費税は内税として表示しております。</dd>

      <dt>利用料以外に発生する料金等</dt>
      <dd>サイトの閲覧、コンテンツのダウンロード、お問い合わせ等の際の電子メールの送受信時などに、所定の通信料が発生します。</dd>

      <dt>決済方法</dt>
      <dd>App Store、Google Playその他当社が指定するプラットフォームが提供する決済方法をご利用いただけます。</dd>

      <dt>サービス提供時期</dt>
      <dd>購入手続き完了後、直ちにご利用いただけます。ただし、通信環境、App Store・Google Play等のプラットフォーム、決済事業者、当社システムの状態により、反映まで時間を要する場合があります。</dd>

      <dt>解約・更新停止</dt>
      <dd>自動更新サブスクリプションの解約または更新停止は、購入に利用したApp Store、Google Playその他のプラットフォームが定める方法に従って行ってください。契約期間途中で解約または更新停止を行った場合でも、原則として契約期間満了日までサービスをご利用いただけます。</dd>

      <dt>返品についての特約事項</dt>
      <dd>デジタルコンテンツおよびサービスの性質上、購入後の返品・キャンセルには応じられません。返金の可否および手続きは、購入に利用したApp Store、Google Playその他のプラットフォームの規約および手続きに従います。</dd>

      <dt>推奨環境</dt>
      <dd>
        <ul>
          <li>OS：最新のOS</li>
          <li>アプリバージョン：App Storeで提供している最新バージョン</li>
        </ul>
      </dd>

      <dt>注意事項</dt>
      <dd>本サービスは、特定商取引法に規定されるクーリング・オフが適用されるサービスではありません。</dd>
    </dl>
  </div>
</template>

<script>
export default {
  name: 'LegalView',
  data() {
    return {
      isMobile: false
    }
  },
  mounted() {
    document.title = '特定商取引法に基づく表記 | メノア';
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth < 768;
    }
  }
};
</script>

<style scoped>
/* 共通スタイル - 見出し設定 */
h1 {
  color: var(--color-green-600);
}

dt {
  font-weight: bold;
  font-size: 18px;
  color: var(--color-grey-500);
}

dd {
  font-size: 18px;
  color: var(--color-grey-500);
}

/* モバイル対応スタイル */
.mobile {
  padding-top: 56px;
  padding-bottom: 56px;
  padding-left: 24px;
  padding-right: 24px;
}

.mobile h1 {
  font-size: 24px;
  margin-bottom: 20px;
  text-align: left;
}

.mobile dt {
  margin-top: 32px;
  font-size: 18px;
}

.mobile dd {
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 32px;
  margin-top: 8px;
}

/* デスクトップ対応スタイル */
.desktop {
  padding-top: 120px;
  padding-bottom: 120px;
  padding-left: 80px;
  padding-right: 80px;
  max-width: 1120px;
  margin: 0 auto;
}

.desktop h1 {
  font-size: 28px;
  padding-bottom: 40px;
  text-align: left;
}

.desktop dt {
  margin-bottom: 8px;
  font-size: 18px;
}

.desktop dd {
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 32px;
}

ul {
  padding-left: 20px;
}
</style>
